"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M11 22h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2zm-1.59-12l3.62-3.62c.19-.19.29-.44.29-.71s-.11-.52-.29-.71L12.7.65c-.29-.29-.72-.37-1.09-.22-.37.15-.61.52-.61.92v6.23L7.14 3.73c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L10.58 10l-4.85 4.85c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L11 12.41v6.23c0 .4.24.77.62.92.12.05.25.08.38.08.26 0 .52-.1.71-.29l4.32-4.32c.19-.19.29-.44.29-.71s-.11-.52-.29-.71L13.41 10zM13 3.77l1.91 1.91L13 7.58V3.77zm0 12.46v-3.82l1.91 1.91L13 16.23z"
}), 'SettingsBluetoothRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/SettingsBluetoothRounded.js
// module id = 4898
// module chunks = 0